import React from "react";
import { Link } from "react-router-dom";
import "../CSS/Apostille.css";
import heroBg from "../Assets/bgimage.jpg";
import apostilleMainImg from "../Assets/certificate-apostille.webp";
import { 
  FaAngleRight, 
  FaCheckCircle, 
  FaClock, 
  FaFileAlt, 
  FaUniversity,
  FaUser,
  FaBriefcase,
  FaGraduationCap,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaArrowRight,
  FaRegFilePdf,
  FaRegCopy,
  FaShieldAlt,
  FaRocket,
  FaHandshake,
  FaGlobe
} from "react-icons/fa";

export default function Apostille() {
  const heroStyle = {
    backgroundImage: `url(${heroBg})`,  
  };

  const documentCategories = [
    {
      title: "Educational Document",
      description: "School certificates, degree certificates, diploma, and professional course certificates",
      icon: <FaGraduationCap />,
      types: ["10th/SSLC", "12th/HSE", "Degree", "Diploma", "MBA", "B.Tech", "MBBS", "PhD", "Nursing", "Engineering"],
      color: "#3b82f6"
    },
    {
      title: "Personal Document",
      description: "Birth certificates, marriage certificates, death certificates, and police clearance certificates",
      icon: <FaUser />,
      types: ["Birth Certificate", "Marriage Certificate", "PCC", "Death Certificate", "Affidavits", "Medical Certificates"],
      color: "#10b981"
    },
    {
      title: "Commercial Document",
      description: "Company registration, export documents, invoices, and power of attorney",
      icon: <FaBriefcase />,
      types: ["Company Registration", "MOA & AOA", "Export Documents", "Invoices", "Power of Attorney", "Trade Marks"],
      color: "#f59e0b"
    }
  ];

  const documentDetails = [
    {
      title: "Apostille On 10th/SSLC Certificate",
      description: "All State educational board or CBSE, NCERT, NIOS and other open universities documents can be attested.",
      checklist: ["Original SSLC / 10th certificate", "Passport copy"],
      processA: "State Board → HRD → MEA → Apostille",
      processB: "SDM/Mantralya → HRD → MEA → Apostille",
      time: "2 Working days",
      icon: <FaRegFilePdf />
    },
    {
      title: "Apostille On HSE, PDC/+2 Certificate",
      description: "All State educational board or CBSE, NCERT, NIOS and other open universities documents can be attested.",
      checklist: ["Original HSE/+2 certificate", "Passport copy"],
      processA: "State Board → HRD → MEA → Apostille",
      processB: "SDM/Mantralya → HRD → MEA → Apostille",
      time: "2 Working days",
      icon: <FaRegCopy />
    },
    {
      title: "Apostille On Degree/Bachelor Certificate",
      description: "All UGC approved universities, deemed universities and private universities documents can be apostilled.",
      checklist: ["Original Degree certificate", "Passport copy"],
      processA: "University → HRD → MEA → Apostille",
      processB: "SDM → MEA → Apostille",
      time: "2 Working days",
      icon: <FaUniversity />
    },
    {
      title: "Apostille On Diploma Certificate",
      description: "All UGC approved universities, deemed universities, polytechnic diploma can be apostilled.",
      checklist: ["Original Diploma certificate", "Passport copy"],
      processA: "University → HRD → MEA → Apostille",
      processB: "SDM → MEA → Apostille",
      time: "2 Working days",
      icon: <FaRegFilePdf />
    },
    {
      title: "Apostille On Professional Certificates",
      description: "CA, CS, ICWA, and other professional course certificates can be apostilled.",
      checklist: ["Original Professional certificate", "Passport copy", "Membership proof"],
      processA: "Institute → HRD → MEA → Apostille",
      processB: "SDM → MEA → Apostille",
      time: "2 Working days",
      icon: <FaShieldAlt />
    }
  ];

  const quickLinks = [
    { name: "Apostille", icon: <FaGlobe /> },
    { name: "Document Apostille", icon: <FaFileAlt /> },
    { name: "MEA approved list of university", icon: <FaUniversity /> },
    { name: "Apostille country list", icon: <FaGlobe /> },
    { name: "Document Apostille Process", icon: <FaRocket /> },
    { name: "Non apostille country list", icon: <FaGlobe /> },
    { name: "Apostille accepted embassy list", icon: <FaHandshake /> },
    { name: "Apostille member countries", icon: <FaGlobe /> }
  ];

  const collectionCenters = [
    "New Delhi", "Mumbai", "Kolkata", "Bangalore", 
    "Chennai", "Hyderabad", "Lucknow", "Chandigarh"
  ];

  return (
    <div className="apostille-page">

      {/* HERO SECTION */}
      <section className="apostille-hero-section" style={heroStyle}>
        <div className="apostille-hero-overlay" />
        <div className="apostille-hero-wrapper">
          <div className="apostille-hero-content">
            <h1 className="apostille-hero-title">Document Apostille Services</h1>
            <div className="apostille-hero-breadcrumb">
              <Link to="/">Home</Link>
              <span className="apostille-breadcrumb-sep"><FaAngleRight /></span>
              <span className="apostille-breadcrumb-current">Apostille Services</span>
            </div>
          </div>
        </div>
      </section>

      {/* INTRODUCTION SECTION */}
      <section className="apostille-intro-section">
        <div className="apostille-container">
          <div className="apostille-intro-grid">
            <div className="apostille-intro-text">
              <div className="apostille-section-tag">APOSTILLE SERVICES</div>
              <h2 className="apostille-section-title">Document Apostille Services</h2>
              <p className="apostille-intro-paragraph">
                Apostille is a certification issued by the Ministry of External Affairs (MEA) that verifies the authenticity of documents for use in countries that are part of the Hague Apostille Convention. We provide comprehensive apostille services for all types of documents with fast processing and doorstep pickup.
              </p>
              
              {/* Contact Cards */}
              <div className="apostille-contact-mini-cards">
                <a href="tel:+916393244687" className="apostille-contact-mini-card">
                  <div className="apostille-mini-icon"><FaPhoneAlt /></div>
                  <div className="apostille-mini-info">
                    <span className="apostille-mini-label">Call Us</span>
                    <span className="apostille-mini-value">+91 6393244687</span>
                  </div>
                </a>
                <a href="mailto:info@apostilleserviceinmumbai.com" className="apostille-contact-mini-card">
                  <div className="apostille-mini-icon"><FaEnvelope /></div>
                  <div className="apostille-mini-info">
                    <span className="apostille-mini-label">Email Us</span>
                    <span className="apostille-mini-value">info@apostilleserviceinmumbai.com</span>
                  </div>
                </a>
              </div>

              <div className="apostille-processing-time-card">
                <FaClock className="apostille-time-icon" />
                <span>Processing Time: <strong>2-5 Working Days</strong></span>
              </div>
            </div>
            <div className="apostille-intro-image">
              <img src={apostilleMainImg} alt="Apostille Services" />
            </div>
          </div>
        </div>
      </section>

      {/* DOCUMENT CATEGORIES */}
      <section className="apostille-categories-section">
        <div className="apostille-container">
          <div className="apostille-section-header">
            <span className="apostille-section-tag">DOCUMENT TYPES</span>
            <h2 className="apostille-section-title">Documents We Apostille</h2>
            <p className="apostille-section-description">We handle all types of documents for apostille attestation</p>
          </div>
          
          <div className="apostille-categories-grid">
            {documentCategories.map((cat, index) => (
              <div className="apostille-category-card" key={index} style={{ borderTopColor: cat.color }}>
                <div className="apostille-category-icon" style={{ background: `${cat.color}15`, color: cat.color }}>
                  {cat.icon}
                </div>
                <h3>{cat.title}</h3>
                <p>{cat.description}</p>
                <div className="apostille-doc-tags">
                  {cat.types.slice(0, 4).map((type, i) => (
                    <span key={i} className="apostille-doc-tag">{type}</span>
                  ))}
                  {cat.types.length > 4 && (
                    <span className="apostille-doc-tag apostille-doc-tag-more" style={{ background: cat.color }}>+{cat.types.length - 4}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* DETAILED DOCUMENTS SECTION */}
      <section className="apostille-details-section">
        <div className="apostille-container">
          <div className="apostille-section-header">
            <span className="apostille-section-tag">COMPREHENSIVE GUIDE</span>
            <h2 className="apostille-section-title">Document Wise Apostille Process</h2>
            <p className="apostille-section-description">Detailed information for each document type</p>
          </div>

          <div className="apostille-details-grid">
            {documentDetails.map((doc, idx) => (
              <div className="apostille-detail-card" key={idx}>
                <div className="apostille-detail-header">
                  <div className="apostille-detail-icon">{doc.icon}</div>
                  <h3>{doc.title}</h3>
                </div>
                <p className="apostille-detail-description">{doc.description}</p>
                
                <div className="apostille-detail-time">
                  <FaClock className="apostille-detail-time-icon" />
                  <span>Processing Time: <strong>{doc.time}</strong></span>
                </div>

                <div className="apostille-detail-checklist">
                  <h4>Document Checklist</h4>
                  <ul>
                    {doc.checklist.map((item, i) => (
                      <li key={i}>
                        <FaCheckCircle className="apostille-check-icon" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="apostille-detail-process">
                  <h4>Process Options</h4>
                  <div className="apostille-process-item">
                    <span className="apostille-process-badge apostille-process-badge-a">A</span>
                    <p>{doc.processA}</p>
                  </div>
                  <div className="apostille-process-item">
                    <span className="apostille-process-badge apostille-process-badge-b">B</span>
                    <p>{doc.processB}</p>
                  </div>
                </div>

                <div className="apostille-detail-note">
                  <strong>NOTE:</strong> Processing time for state level authentication (HRD) varies as per state. Standard HRD authentication time would be 15-30 working days.
                </div>

                <div className="apostille-detail-expert">
                  <FaPhoneAlt className="apostille-expert-icon" />
                  <span>Call our expert: </span>
                  <a href="tel:+916393244687" className="apostille-expert-phone">+91 6393244687</a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PROCESS STEPS */}
      <section className="apostille-steps-section">
        <div className="apostille-container">
          <div className="apostille-section-header apostille-section-header-light">
            <span className="apostille-section-tag">SIMPLE PROCESS</span>
            <h2 className="apostille-section-title">How Apostille Works</h2>
            <p className="apostille-section-description">Four simple steps to get your documents apostilled</p>
          </div>

          <div className="apostille-steps-grid">
            <div className="apostille-step-card">
              <div className="apostille-step-number">1</div>
              <div className="apostille-step-content">
                <h4>Document Submission</h4>
                <p>Submit your documents via courier or doorstep pickup</p>
              </div>
            </div>
            <div className="apostille-step-card">
              <div className="apostille-step-number">2</div>
              <div className="apostille-step-content">
                <h4>Notary Attestation</h4>
                <p>Initial notary verification of documents</p>
              </div>
            </div>
            <div className="apostille-step-card">
              <div className="apostille-step-number">3</div>
              <div className="apostille-step-content">
                <h4>State/HRD Attestation</h4>
                <p>Verification from respective state authorities</p>
              </div>
            </div>
            <div className="apostille-step-card">
              <div className="apostille-step-number">4</div>
              <div className="apostille-step-content">
                <h4>MEA Apostille</h4>
                <p>Final apostille from Ministry of External Affairs</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* QUICK LINKS SECTION */}
      <section className="apostille-quicklinks-section">
        <div className="apostille-container">
          <div className="apostille-quicklinks-grid">
            <div className="apostille-quicklinks-column">
              <h3>Quick Links</h3>
              <ul>
                {quickLinks.slice(0, 4).map((link, i) => (
                  <li key={i}>
                    <Link to="#">
                      <span className="apostille-link-icon">{link.icon}</span>
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="apostille-quicklinks-column">
              <h3>Resources</h3>
              <ul>
                {quickLinks.slice(4, 8).map((link, i) => (
                  <li key={i}>
                    <Link to="#">
                      <span className="apostille-link-icon">{link.icon}</span>
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="apostille-quicklinks-column">
              <h3>Collection Centers</h3>
              <ul>
                {collectionCenters.map((center, i) => (
                  <li key={i}>
                    <Link to="#">
                      <FaMapMarkerAlt className="apostille-link-icon" />
                      {center}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="apostille-quicklinks-column apostille-contact-column">
              <h3>Contact Info</h3>
              <div className="apostille-contact-details">
                <a href="tel:+916393244687" className="apostille-contact-item">
                  <FaPhoneAlt className="apostille-contact-icon" />
                  <span>+91 6393244687</span>
                </a>
                <a href="mailto:info@apostilleserviceinmumbai.com" className="apostille-contact-item">
                  <FaEnvelope className="apostille-contact-icon" />
                  <span>info@apostilleserviceinmumbai.com</span>
                </a>
                <div className="apostille-contact-item apostille-contact-address">
                  <FaMapMarkerAlt className="apostille-contact-icon" />
                  <span>Room 18, Vishwakarma Bhavan, Khar East, Mumbai 400051</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="apostille-cta-section">
        <div className="apostille-container">
          <h2 className="apostille-cta-title">Need Apostille Services?</h2>
          <p className="apostille-cta-description">Get your documents apostilled quickly with our expert assistance</p>
          <div className="apostille-cta-buttons">
            <Link to="/contact" className="apostille-btn-primary">
              Contact Us <FaArrowRight />
            </Link>
            <Link to="/faq" className="apostille-btn-secondary">
              FAQ <FaArrowRight />
            </Link>
          </div>
        </div>
      </section>

    </div>
  );
}